"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Icon = styled_components_1.default.svg `
    ${({ isDisabled, isError, theme }) => {
    if (isDisabled) {
        return (0, styled_components_1.css) `
                polygon {
                    fill: ${theme.colorControlIconDisabled};
                }
            `;
    }
    if (isError) {
        return (0, styled_components_1.css) `
                polygon {
                    fill: ${theme.colorControlIconError};
                }
            `;
    }
    return (0, styled_components_1.css) `
            polygon {
                fill: ${theme.colorControlIcon};
            }
        `;
}}
`;
const ClearIcon = (_a) => {
    var { disabled = false, error = false } = _a, rest = __rest(_a, ["disabled", "error"]);
    return (react_1.default.createElement(Icon, Object.assign({}, rest, { viewBox: "0 0 16 16", width: "16px", height: "16px", isDisabled: disabled, isError: error }),
        react_1.default.createElement("polygon", { points: "16 1.413 14.587 0 8 6.587 1.413 0 0 1.413 6.587 8 0 14.587 1.413 16 8 9.413 14.587 16 16 14.587 9.413 8 16 1.413" })));
};
exports.ClearIcon = ClearIcon;
//# sourceMappingURL=ClearIcon.js.map